<template>
  <div class="container" v-if="!loading && isResult">
    <div class="header">
      <img src="https://oss.turingsenseai.com/1719553978342058669.jpg" alt="" srcset="">
    </div>
    <div class="content">
      <div class="title">
        <img src="https://oss.turingsenseai.com/1719544638458427561.jpg" alt="" srcset="">
      </div>
      <div class="main">
        <img class="mark" :src="['https://oss.turingsenseai.com/1719552188748479622.jpg', 'https://oss.turingsenseai.com/1719913749695660924.jpg', 'https://oss.turingsenseai.com/1719913813375594999.jpg','https://oss.turingsenseai.com/1727259407903212079.jpg'][jdReportDetail.result-1]" alt="" srcset="">
        <div class="item mb36">
          <div class="label mb24">
            <span class="icon"></span>
            <span class="des-name">品类/品牌/系列</span>
          </div>
          <div class="value">
            <span class="true-value">{{kindBrandSeries}}</span>
          </div>
        </div>
        <div class="item mb36">
          <div class="label mb24">
            <span class="icon"></span>
            <span class="des-name">证书编号</span>
          </div>
          <div class="value">
            <span class="true-value">{{ jdReportDetail.certNo||'-' }}</span>
          </div>
        </div>
        <div class="item">
          <div class="label">
            <span class="icon"></span>
            <span class="des-name">鉴定图片</span>
          </div>
          <div class="value">
            <div class="true-value">
              <img @click="previewImage(it,i)" v-for="(it,i) in jdReportDetail.identificationImage.slice(0, 6)" :key="it" :src="it+'?x-oss-process=image/resize,h_700,w_700'" alt="" srcset="">
              <!-- <img src="https://oss.turingsenseai.com/1719552749480610417.jpg" alt="" srcset=""> -->
            </div>
          </div>
        </div>
      </div>
      <div class="desc">上述鉴定结果由宁波海关技术中心支持</div>
    </div>
    <div class="footer">由图灵鉴定提供信息系统支持</div>
  </div>
  <div class="no-result" v-else>
    <van-loading v-if="loading" size="60">加载中...</van-loading>
    <div v-else>鉴别结果未出，暂时无法查看报告，请稍后~</div>
  </div>
</template>

<script>

import { ImagePreview } from "vant";
import {fetchAppraisalJDReport} from '@/common/api/appraisal.js'
export default {
  data() {
    return {
      loading: true,
      isResult: false,
      jdReportDetail: {}
    };
  },
  computed: {
    kindBrandSeries(){
      let kindName = this.jdReportDetail.kindName || '-'
      let brandName = this.jdReportDetail.brandName || '-'
      let seriesName = this.jdReportDetail.seriesName || '-' 
      return kindName + '/' + brandName + '/' + seriesName
    }
  },
  created() {
    console.log(this.$route.params, 'this.$router.params')
  },
  mounted() {
    this.getReport()
  },

  methods: {
    getReport() {
      fetchAppraisalJDReport({qrCode: this.$route.params.code}).then(res => {
        if(!res.errorCode) {
          console.log(res)
          this.jdReportDetail = res
          if (res.result===0) {
            this.isResult = false
          }else {
            this.isResult = true
          }
        }else {
          this.isResult = false
        }
      }).finally(() => {
        this.loading = false
      })
    },
    previewImage(src,startPosition) {
      let images = this.jdReportDetail.identificationImage.slice(0, 6).map(it => it)
      ImagePreview({images, startPosition})
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  background: #f5f6fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  .header{
    height: 181*2px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .content {
    position: relative;
    width: 351*2px;
    margin-top: 32px;
    border-radius: 16px;
    background: #ffffff;
    .title {
      margin-top: 12*2px;
      display: flex;
      justify-content: center;
      img {
        width: 214*2px;
        height: 33*2px;
      }
    }
    .main{
      width: 319*2px;
      margin: 0 auto;
      .mb24 {
        margin-bottom: 24px
      }
      .mb36 {
        margin-bottom: 36px
      }
      .mark {
        width: 140*2px;
        height: 160*2px;
        position: absolute;
        top: 69*2px;
        left: 211*2px;
      }
      .item {
        margin-top: 12*2px;
        .label {
          display: flex;
          align-items: center;
          .icon {
            display: inline-block;
            width: 3*2px;
            height: 12*2px;
            background: #203c85;
          }
          .des-name {
            margin-left: 4*2px;
            font-size: 12*2px;
            color: #B4B5BE;
          }
        }
        .value {
          margin-top: 6*2px;
          margin-left: 8*2px;
          .true-value {
            font-weight: 600;
            font-size: 14*2px;
            color: #3A3D44;
            img {
              background-color: #e9e9e9;
              width: 91*2px;
              height: 91*2px;
              border-radius: 8*2px;
              object-fit: contain;
              margin-right: 15*2px;
              margin-bottom: 15*2px;
            }
            img:nth-child(3n) {
              margin-right: 0;
            } 
          }
        }
      }

    }
    .desc {
      margin-bottom: 11*2px;
      font-size: 12*2px;
      color: #B4B5BE;
      text-align: center;
    }
  }
  .footer {
    margin-top: 12*2px;
    font-size: 12*2px;
    color: #B4B5BE;
  }
}
.no-result {
  display: flex;
  justify-content: center;
  align-items: center;
  .van-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>